import { observer } from "mobx-react";
import React from "react";
import { ContactGroup } from "../../api/firebase/types/contact.types";
import ContactGroupStore from "../../store/ContactGroupStore";
import GenericPickList from "./GenericPickList";

type ContactGroupPickListProps = {
  onChange: (contactGroupIds: string[]) => void;
  selectedContactGroupIds: string[];
};

const ContactGroupPickList: React.FC<ContactGroupPickListProps> = (props) => {
  const { contactGroups } = ContactGroupStore;

  return (
    <GenericPickList<ContactGroup>
      options={contactGroups}
      selectedOptionIds={props.selectedContactGroupIds}
      filterBy="label"
      sourceFilterPlaceholder="Suche nach Bezeichnung..."
      targetFilterPlaceholder="Suche nach Bezeichnung..."
      onChange={(contactGroups) =>
        props.onChange(contactGroups.map((group) => group.id))
      }
      itemTemplate={(contactGroup: ContactGroup) => (
        <div>{contactGroup.label}</div>
      )}
    />
  );
};
export default observer(ContactGroupPickList);
